import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DataIntegrationForm from "./dataIntegrationComponents/DataIntegrationForm";
import { useAddDataIntegrationMutation } from "store/services/dataIntegrationApi";

const DataIntegrationCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Data Integration", path: "/app/crm/dataIntegration/list" },
    { title: "New Data Integration" },
  ];

  // RTK query hook for adding DataIntegration
  const [addDataIntegration, { isLoading }] = useAddDataIntegrationMutation();

  const handleCreateDataIntegration = async (data) => {
    try {
      const { _id } = await addDataIntegration(data).unwrap();
      toast.success("Data Integration successfully created!");
      navigate(`/app/crm/dataIntegration/${_id}/detail`); // Navigate to the newly created DataIntegration's detail page
    } catch (err) {
      toast.error(
        err?.data?.message ?? err?.message ?? "Couldn't create Data Integration!"
      );
    }
  };

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={isLoading}>
      <BreadcrumbLayout.Paper>
        <DataIntegrationForm isBusy={isLoading} onSubmit={handleCreateDataIntegration} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DataIntegrationCreateScreen;
